import { dynamicDescription } from '@sellpy/commons'
import { Link, useLocation } from 'react-router-dom'
import { locale, localizedMetadata } from '../../common/region/config'

/**
 * @param {Object} props
 * @param {Function} props.component
 * @param {Object} props.item
 */
const BaseComponent = ({
  component: Component,
  item,
  outputFunction,
  itemTitleFunction,
  defaultValue,
  ...rest
}) => {
  const metadata = item.get(localizedMetadata) || item.get('metadata')
  const data = {
    metadata,
    titleOrder: item.get('titleOutputOrder'),
    bodyOrder: item.get('bodyOutputOrder'),
    locale
  }

  return <Component {...rest}>{(metadata && outputFunction(data)) || defaultValue}</Component>
}

export const ItemTitle = (props) => (
  <BaseComponent outputFunction={dynamicDescription.itemTitle} {...props} />
)

export const ItemSubtitle = ({ defaultValue, ...rest }) => {
  return (
    <BaseComponent
      outputFunction={dynamicDescription.itemSubtitleV2}
      itemTitleFunction={dynamicDescription.itemTitle}
      defaultValue={rest.item.get('metadata') ? defaultValue : rest.item.get('headline')}
      {...rest}
    />
  )
}

export const ItemLink = ({ linkTo, children, className, ...rest }) => {
  const location = useLocation()
  return (
    <Link
      reloadDocument={window.appUpdateAvailable}
      to={linkTo}
      className={className}
      {...rest}
      state={{ from: location.pathname + location.search }} // This is needed for useSimilarItemsForGrid to be able to register favorites from the PDP page.
    >
      {children}
    </Link>
  )
}
